<template>
    <div>
        <section class="content-header mt-2">
            <h1 class="pull-left">
                <font-awesome-icon icon="users"/>
                Adding User
            </h1>
        </section>
        <div class="content">
            <error-component
                    v-if="exceptions.length > 0"
                    v-bind="exceptions[0]">
            </error-component>
            <success-component
                    v-if="success.length > 0"
                    :message="success">
            </success-component>
            <b-form v-if="exists" @submit.prevent="onSubmit">
                <b-form-group
                        label="Email:"
                        label-for="email">
                    <b-form-input name="email"
                                  type="email"
                                  autofocus
                                  v-model="email"
                                  v-validate="{required:true, email:true}"
                                  :state="errors.has('email') ? false: null"
                                  placeholder="Enter user email">
                    </b-form-input>
                    <em v-if="errors.has('email')" class="text-danger">
                        {{ errors.first('email') }}
                    </em>
                </b-form-group>
                <b-button variant="success" :disabled="loadingRun" @click="onSubmit" class="mr-2">
                    <span>Save</span>
                    <b-spinner
                        v-if="loadingRun"
                        small
                        class="ml-2" />
                </b-button>
                <b-link class="btn btn-secondary" :to="{ name : 'organization.users' }">
                    <a>Back</a>
                </b-link>
            </b-form>
            <b-form v-else @submit.prevent="create">
                <span><strong> This user doesn't exist, you have to create an account</strong></span>
                <b-form-group
                        label="Name:"
                        label-for="name">
                    <b-form-input name="name"
                                  type="text"
                                  autofocus
                                  v-model="name"
                                  v-validate="{required:true}"
                                  :state="errors.has('name') ? false: null"
                                  placeholder="Enter user name">
                    </b-form-input>
                    <em v-if="errors.has('name')" class="text-danger">
                        {{ errors.first('name') }}
                    </em>
                </b-form-group>
                <b-form-group
                        label="Email:"
                        label-for="email">
                    <b-form-input name="email"
                                  type="email"
                                  autofocus
                                  v-model="email"
                                  v-validate="{required:true, email:true}"
                                  :state="errors.has('email') ? false: null"
                                  placeholder="Enter user email">
                    </b-form-input>
                    <em v-if="errors.has('email')" class="text-danger">
                        {{ errors.first('email') }}
                    </em>
                </b-form-group>
                <b-button variant="success" :disabled="loadingRun" @click="create" class="mr-2">
                    <span>Create</span>
                    <b-spinner
                        v-if="loadingRun"
                        small
                        class="ml-2" />
                </b-button>
                <b-link class="btn btn-secondary" :to="{ name : 'organization.users' }">
                    <a>Back</a>
                </b-link>
            </b-form>
        </div>
    </div>
</template>

<script>
    import SuccessComponent from '../../../components/Success.vue';
    import ErrorComponent from '../../../components/ErrorView.vue';
    import {mapState} from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        props: ['organization_id'],
        data() {
            return {
                email: '',
                name: '',
                loadingRun: false
            }
        },
        components: {
            SuccessComponent,
            ErrorComponent
        },
        beforeDestroy() {
            this.$store.commit('CLEAR_EXCEPTIONS');
            this.$store.commit('SET_EXISTS', true);
        },
        computed: {
            ...mapState({
                success: 'success',
                exceptions: 'exceptions',
                exists: 'exists'
            })
        },
        methods: {
            onSubmit() {
                this.$validator.validateAll().then((valid) => {
                    if (valid) {
                        this.loadingRun = true;
                        this.setUserOrganization();
                    }
                })
            },
            create() {
                this.$validator.validateAll().then((valid) => {
                    if (valid) {
                        this.loadingRun = true;
                        this.$auth.register({
                            data: {
                                name: this.name,
                                email: this.email,
                                active: 0
                            },
                            url: 'users/unactive',
                            success: function () {
                                this.setUserOrganization();
                            },
                            error: function (error) {
                                this.loadingRun = false;
                                this.$store.dispatch('setExceptions', error.response.data);
                            },
                            redirect: null
                        });
					          }
				        })
			      },
            setUserOrganization() {
            let payload = {
              id: this.organization_id,
              email: this.email
            };
            this.$store.dispatch('addUser', payload).finally(() => {
              this.loadingRun = false;
            });
            }
		}
		
	}
</script>